export const CheckmarkCell = (props) => {
  return props.checked ?
    (
      <td>
        <span className='k-icon k-i-check' />
      </td>
    ) : (
      <td></td>
    );
}